import type { SVGProps } from "react";
export interface Certified02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Certified02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Certified02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.431 1.566c.837-.92 2.3-.92 3.137 0l.17.211.723 1.03 1.146-.529.252-.098a2.127 2.127 0 0 1 2.715 1.57l.041.266.113 1.255 1.255.113a2.126 2.126 0 0 1 1.738 3.01l-.529 1.141 1.03.728.21.169a2.126 2.126 0 0 1-.21 3.306l-1.031.725.53 1.144a2.125 2.125 0 0 1-1.738 3.009l-1.255.113-.113 1.255a2.125 2.125 0 0 1-3.008 1.737l-1.144-.53-.726 1.031a2.125 2.125 0 0 1-3.474 0l-.728-1.03-1.141.53a2.126 2.126 0 0 1-3.01-1.738l-.113-1.255-1.256-.113a2.125 2.125 0 0 1-1.737-3.009l.529-1.146-1.03-.723a2.125 2.125 0 0 1 0-3.475l1.03-.726-.529-1.143a2.126 2.126 0 0 1 1.737-3.01l1.256-.113.112-1.255.041-.267A2.127 2.127 0 0 1 8.14 2.18l.254.098 1.142.53.727-1.03zm.885 2.623a2.125 2.125 0 0 1-2.63.704l-1.077-.5-.107 1.184a2.124 2.124 0 0 1-1.925 1.925l-1.184.107.5 1.078c.404.874.169 1.9-.554 2.512l-.15.117-.972.683.971.684.151.117c.675.572.925 1.505.627 2.337l-.073.177-.5 1.075 1.184.109c.958.086 1.73.804 1.9 1.735l.025.19.107 1.182 1.078-.498.175-.072a2.125 2.125 0 0 1 2.337.625l.117.151.683.971.684-.97.117-.152a2.125 2.125 0 0 1 2.336-.625l.178.072 1.075.498.108-1.183.027-.189a2.12 2.12 0 0 1 1.898-1.735l1.182-.109-.498-1.075a2.126 2.126 0 0 1 .705-2.63l.97-.685-.97-.683a2.125 2.125 0 0 1-.705-2.629l.498-1.078-1.182-.107a2.124 2.124 0 0 1-1.898-1.736l-.027-.189-.108-1.183-1.075.5a2.125 2.125 0 0 1-2.514-.555l-.117-.15-.684-.972z"
      />
      <path
        fill={color}
        d="M14.704 8.705a1.125 1.125 0 0 1 1.59 1.59l-4.5 4.5c-.439.44-1.15.44-1.59 0l-2-1.999-.077-.086a1.125 1.125 0 0 1 1.583-1.582l.085.077L11 12.41z"
      />
    </svg>
  );
}
